import React from 'react';
import { LegalPage } from '@/components/public/LegalPage';

// Contenuti definitivi gestiti dal CRM (page:privacy-sicurezza).
// Config = fallback minimo se il CMS non ha ancora contenuti.
const CONFIG = {
  eyebrow: 'Privacy & Sicurezza',
  title: 'Privacy & Sicurezza',
  lead: 'Raccolta ufficiale di tutti i documenti relativi a privacy, sicurezza, trasparenza e governance della piattaforma.',
  updated: '30 settembre 2026',
  sections: [],
};

export default function PrivacySicurezza() {
  return <LegalPage slug="privacy-sicurezza" config={CONFIG} />;
}
